import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, TrendingUp } from 'lucide-react';
interface Props {
  onNext: () => void;
}
const options = [{
  id: 'excited',
  label: 'More excited than ever',
  percent: 71
}, {
  id: 'optimistic',
  label: 'Cautiously optimistic',
  percent: 21
}, {
  id: 'curious',
  label: "Curious to see what's next",
  percent: 8
}];
export const PostScreenPollFuture = ({
  onNext
}: Props) => {
  const [selected, setSelected] = useState<string | null>(null);
  const [revealed, setRevealed] = useState(false);
  const handleSelect = (id: string) => {
    if (revealed) return;
    setSelected(id);
    setTimeout(() => setRevealed(true), 600);
  };
  return <div className="relative w-full h-full bg-slate-950 overflow-hidden flex flex-col" data-id="element-151">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 via-slate-950 to-slate-950" data-id="element-152" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-green-700/15 rounded-full blur-[100px]" data-id="element-153" />

      <div className="relative z-10 flex-1 flex flex-col p-8 pt-16" data-id="element-154">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-green-500 font-semibold mb-4" data-id="element-155">
          06 — Looking Ahead
        </motion.span>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="w-12 h-12 bg-green-500/20 rounded-2xl flex items-center justify-center mb-6 border border-green-500/30" data-id="element-156">
          <TrendingUp className="w-6 h-6 text-green-500" data-id="element-157" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-2xl font-bold text-white leading-tight mb-8" data-id="element-158">
          After ERA, how do you feel about what's next?
        </motion.h2>

        <div className="space-y-3 flex-1" data-id="element-159">
          {options.map((opt, i) => {
          const isSelected = selected === opt.id;
          return <motion.button key={opt.id} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2 + i * 0.1
          }} onClick={() => handleSelect(opt.id)} disabled={revealed} className={`relative w-full text-left p-4 rounded-2xl border transition-all duration-500 overflow-hidden ${!revealed ? isSelected ? 'bg-green-600/20 border-green-500 text-white' : 'bg-slate-900/80 border-slate-800 text-slate-300 hover:border-slate-600' : isSelected ? 'bg-slate-800 border-green-500 text-white' : 'bg-slate-900/50 border-slate-800 text-slate-400'}`} data-id="element-160">
                {revealed && <motion.div initial={{
              width: 0
            }} animate={{
              width: `${opt.percent}%`
            }} transition={{
              duration: 1,
              ease: 'easeOut'
            }} className={`absolute inset-y-0 left-0 ${isSelected ? 'bg-green-600/30' : 'bg-slate-700/30'}`} data-id="element-161" />}
                <div className="relative z-10 flex justify-between items-center" data-id="element-162">
                  <span className="text-sm font-medium" data-id="element-163">{opt.label}</span>
                  {revealed && <motion.span initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} transition={{
                delay: 1
              }} className={`text-sm font-bold ${isSelected ? 'text-green-400' : 'text-slate-500'}`} data-id="element-164">
                      {opt.percent}%
                    </motion.span>}
                </div>
              </motion.button>;
        })}
        </div>

        <AnimatePresence data-id="element-165">
          {revealed && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="mt-6" data-id="element-166">
              <p className="text-sm text-slate-400 italic text-center mb-4" data-id="element-167">
                The momentum is building.
              </p>
              <button onClick={onNext} className="w-full bg-green-600 hover:bg-green-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 transition-all active:scale-[0.98]" data-id="element-168">
                <span data-id="element-169">Continue</span>
                <ArrowRight className="w-5 h-5" data-id="element-170" />
              </button>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
};